<lib-alert-toast-stack></lib-alert-toast-stack>

<!-- Auth Routes - No sidebar/topbar wrapper -->
<div *ngIf="isAuthRoute" class="auth-route-container">
  <router-outlet></router-outlet>
</div>

<!-- Reconnecting banner (SignalR retrying) -->
<div
  *ngIf="!isAuthRoute && isAuthenticated && (connectionStatus$ | async) === 'reconnecting'"
  class="signalr-reconnecting-banner"
  role="status"
  aria-live="polite"
>
  Connection lost - reconnecting…
</div>

<!-- Session held but not confirmed (server unreachable at startup): keep the shell, retry -->
<div *ngIf="sessionUnresolved" class="session-unresolved-banner" role="alert" aria-live="assertive">
  <span>Can't reach the server to confirm your session — retrying automatically.</span>
  <button type="button" class="session-unresolved-retry" (click)="retrySessionInit()">Retry now</button>
</div>

<!-- SignalR connection lost overlay: block usage until reload -->
<div
  *ngIf="!isAuthRoute && isAuthenticated && (connectionLost$ | async)"
  class="signalr-connection-lost-overlay"
  role="alert"
  aria-live="assertive"
>
  <div class="signalr-connection-lost-card">
    <mat-icon class="signalr-error-icon">cloud_off</mat-icon>
    <h2 class="signalr-connection-lost-title">Connection lost</h2>
    <p class="signalr-connection-lost-message">
      The connection to the server was lost. Please reload the page to continue.
    </p>
    <button mat-flat-button color="primary" (click)="reloadPage()" type="button">
      Reload page
    </button>
  </div>
</div>

<!-- Main App Layout - Only show when NOT on auth routes -->
<mat-sidenav-container *ngIf="!isAuthRoute" class="sidenav-container" [@.disabled]="true">
  <!-- Sidebar - Only show when authenticated -->
  <mat-sidenav
    *ngIf="isAuthenticated"
    #sidenav
    [mode]="isMobile ? 'over' : 'side'"
    [(opened)]="sidebarOpened"
    class="sidenav"
    fixedInViewport="true"
    [disableClose]="!isMobile"
    [@.disabled]="true"
  >
    <app-sidebar></app-sidebar>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content [@.disabled]="true">
    <!-- Topbar -->
    <header class="topbar" *ngIf="isAuthenticated">
      <button
        mat-icon-button
        class="menu-toggle"
        (click)="toggleSidebar()"
        aria-label="Toggle sidebar"
        type="button"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <div class="topbar-content">
        <h1 class="page-title">{{ getPageTitle() }}</h1>
      </div>

      <!-- Notifications + User menu -->
      <marina-topbar-notifications
        [items]="(notificationItems$ | async) ?? []"
        [unreadCount]="(notificationUnreadCount$ | async) ?? 0"
        [loading]="(notificationLoading$ | async) ?? false"
        (openMenu)="onNotificationsMenuOpen()"
        (itemClick)="onNotificationItemClick($event)"
        (markAllRead)="onNotificationMarkAllRead()"
      ></marina-topbar-notifications>
      <marina-topbar-user-menu
        [currentUser$]="currentUser$"
        (logout)="logout()"
      ></marina-topbar-user-menu>
    </header>

    <!-- Main Content Area -->
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
